import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _snakeCase from 'lodash/snakeCase';

import { selectUserVenues } from 'selectors/general';
import { createStaffAccount } from './StaffAccounts.saga';
import StaffAccountModal from './StaffAccountModal';
import { syncValidator as validate } from './StaffAccountModal.validator';
import { selectUserVenueIds } from './StaffAccounts.selectors';

const FORM_NAME = 'ADD_STAFF_ACCOUNT_MODAL';

export const mapStateToProps = (state, ownProps) => {
  const { accountType } = ownProps;

  const venues = selectUserVenues(state);
  const venueIds = selectUserVenueIds(state);

  return {
    ...ownProps,
    venues,
    initialValues: {
      venueIds,
      role: _snakeCase(accountType),
    },
  };
};

const mapDispatchToProps = {
  onSubmit: createStaffAccount,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({ form: FORM_NAME, validate, enableReinitialize: true })
)(StaffAccountModal);
